import * as actionTypes from './actionTypes';

export const toggleUpdateModal=()=>({
    type:actionTypes.TOGGLE_THREE_D_WIN_PERCENT_UPDATE
})